import React, { useEffect, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { useHistory } from "react-router-dom"
import { useLocation, useParams } from "react-router"
import "bootstrap/dist/css/bootstrap.min.css"
import FOLDER_ICON from "../../../assets/images/Folder-icon.png"
import TRASH_ICON from "../../../assets/images/trash-can-icon-png-19.jpg"
import EDIT_ICON from "../../../assets/images/edit_318-864151.avif"
import PLUS_ICON from "../../../assets/images/plus-icon.png"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  Card,
  CardBody,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {
  deleteVendor_media,
  getVendor_media,
} from "../../../store/vendor_media/actions"
import { addFolder, deleteFolder, getFolders, renameFolder } from "../../../helpers/backend_helper"
import moment from "moment"

function VendorFileManager() {
  const history = useHistory()
  const params = useParams()
  const location = useLocation()
  const [vendor, setVendor] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [offset, setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)
  const [modal, setModal] = useState(false)
  const [folders,setFolders] = useState([])
  const [folderName,setFolderName] = useState('')
const [folderid,setfolderid] = useState(0)

  const dispatch = useDispatch()
  const loading = useSelector(state => state.vendors.vendor_media.loading)
  const _getFolders = async  () =>{
      try{
              const result = await getFolders({ id: params.id, offset, page_size })
      if(result.success){
        setFolders(result.data)
      }
      }catch(e){
      }

    }
  useEffect(() => {
  
    _getFolders()

  }, [ offset, page_size])



  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor => {
    setVendor(vendor)
    setDeleteModal(true)
  }

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)

    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const ceremony = arg
    setFolderName(ceremony.name)
    setfolderid(ceremony.id)
    setIsEdit(true)
    toggle()
  }, [toggle])

  const hadnleAddFolder = async () =>{
    if (isEdit) {
      
      await renameFolder({
        Folder_id:folderid, Folder_name:folderName, date:moment(Date.now()).format('DD-MMM-YYYY, hh:mm A')
      })
      _getFolders()
     setFolderName('')

      setModal(false)

    } else {
        let body = {
          id:params.id,
          name:folderName,
          created_at:moment(Date.now()).format('DD-MMM-YYYY, hh:mm A')
        }
      // save new ceremony
     await  addFolder(body)
     _getFolders()
     setFolderName('')
     setModal(false)

    }
    // toggle()
  }

  const handleDeleteUser = async () => {
    if (vendor.id) {
      try{
            await deleteFolder({id:vendor.id})
     _getFolders()
     setDeleteModal(false)
      }catch(e){
        console.log(e)
     setDeleteModal(false)

      }
 
    }
  }
  
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
    }
  }, [loading])

 

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="MENU"
            breadcrumbItem={location?.state?.vendor_name}
          />
          <Row>
            <Col xs="12">
              {/* <Card> */}
                {/* <CardBody> */}
                  <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
                  <div onClick={()=>setModal(true)} className="col-1" style={{backgroundColor:'white',boxShadow:'0 0 10px rgba(0, 0, 0, 0.2)',borderRadius:5,display:'flex',justifyContent:'center'}}>
                  <img style={{alignSelf:'center'}} src={PLUS_ICON} width={'40%'}/>
                    </div>
                    {
                  folders.length > 0 ? 
                  folders.map(folder=>(

                    <Card key={folder.id}  className="col-3" style={{textAlign:'center',display:'flex',flexDirection:'column'}} >
                      <div style={{display:'flex',float:'right'}}>
                        <div onClick={()=>handleUserClick(folder)} >
                        <img  src={EDIT_ICON} width={'10%'} />
                      </div>
                      <div onClick={()=>onClickDelete(folder)} >
                        <img  src={TRASH_ICON} width={'10%'} />
                      </div>
                      </div>
                       
                      <div onClick={()=>history.push('files/'+folder.id)}>
                         <img style={{alignSelf:'center'}} src={FOLDER_ICON} width={'40%'}/>
                      <div style={{textAlign:'center '}}> <Label>{folder.name}</Label></div>
                      </div>
                     
                    </Card>
                  )) : null
                 }
                 
                 
                  </div>
                {/* </CardBody>
              </Card> */}
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "edit name" : "Add folder"}
            </ModalHeader>
            <ModalBody>
            <div className="mb-3">
                      <Label className="form-label">Name</Label>
                      <Input
                        name="name_fr"
                        type="text"
                        onChange={(e)=>setFolderName(e.target.value)}
                        value={folderName}
                    
                      />

                    </div>
                    <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success save-user"
                          onClick={()=>hadnleAddFolder()}
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
            </ModalBody>
            </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
VendorFileManager.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VendorFileManager
